import { ActiveSection } from './types';

export const STATUS_OPTIONS = [
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'DRAFT',     label: 'Draft'     },
  { value: 'UNPUBLISH', label: 'Unpublish' },
];

export const SECTION_HUMAN: Record<ActiveSection, string> = {
  header: 'Nav-header',
  footer: 'Nav-footer',
};

export const SECTION_KEY: Record<ActiveSection, string> = {
  header: 'NV-001',
  footer: 'NV-002',
};